<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame">
<p class="Author-tp ParaOverride-1" lang="en-GB">Mary Joseph</p>
<p class="Title-tp" lang="en-GB">The Flared Black Skirt</p>
<p class="Subtitle-tp _idGenParaOverride-1" lang="en-GB">Selected Poems</p>
<div class="_idGenObjectLayout-1">
<div class="Imprint" id="_idContainer000">
<img alt="" class="_idGenObjectAttribute-1" src="image/Logo-for-titlepages-new-bw.png"/>
</div>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781398406179_EPUB1.vue?6502bb7e